var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { loadFilterFromUrl } from '../utils/loaderv2';
import { Button, CircularProgress, Container, TextField, Typography, } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomizeTab } from '../components/tabs/CustomizeTab';
import { DEFAULT_FILTER_CONFIGURATION, } from '../parsing/UiTypesSpec';
import { parseAsync as parse } from '../parsing/parse';
import { useFilterConfigStore } from '../store/filterConfigurationStore';
import { useFilterStore } from '../store/filterStore';
import { colors } from '../styles/MuiTheme';
import { parseComponent } from '../utils/link';
export var ImportPage = function () {
    var _a, _b, _c;
    var searchParams = useSearchParams()[0];
    var importData = searchParams.get('importData');
    var filterId = searchParams.get('filterId');
    var updateFilter = useFilterStore().updateFilter;
    var setActiveFilter = useFilterStore().setActiveFilter;
    var setFilterConfiguration = useFilterConfigStore().setFilterConfiguration;
    var navigate = useNavigate();
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(false), loadingFilter = _e[0], setLoadingFilter = _e[1];
    var _f = useState(null), parsedFilter = _f[0], setParsedFilter = _f[1];
    var _g = useState(null), filterUrl = _g[0], setFilterUrl = _g[1];
    var _h = useState(null), filterConfig = _h[0], setFilterConfig = _h[1];
    useEffect(function () {
        if (!importData && !filterId) {
            setError(new Error('No import data'));
            return;
        }
        setLoadingFilter(true);
        if (importData) {
            parseComponent(importData)
                .then(function (_a) {
                var filterUrl = _a.filterUrl, config = _a.config;
                setFilterUrl(filterUrl);
                setFilterConfig(config);
                return loadFilterFromUrl(filterUrl);
            })
                .then(function (filter) { return ({ filter: filter }); })
                .then(function (parsed) {
                setParsedFilter(parsed);
                setError(null);
                setLoadingFilter(false);
            })
                .catch(function (err) {
                setParsedFilter(null);
                setError(err);
                setLoadingFilter(false);
            });
        }
        if (filterId) {
            fetch("https://api.kaqemeex.net/filter/".concat(filterId))
                .then(function (res) { return res.json(); })
                .then(function (_a) {
                var _b = _a.filter, rs2f = _b.rs2f, sourceUrl = _b.sourceUrl, commit = _b.commit, revisionUrl = _b.revisionUrl, config = _a.config;
                setFilterUrl(sourceUrl);
                setFilterConfig(config);
                return parse(rs2f).then(function (parsed) { return (__assign(__assign({}, parsed), { filter: parsed.filter
                        ? __assign(__assign({}, parsed.filter), { commit: commit, revisionUrl: revisionUrl }) : undefined })); });
            })
                .then(function (parsed) {
                setParsedFilter(parsed);
                setError(null);
                setLoadingFilter(false);
            })
                .catch(function (err) {
                console.error(err);
                setParsedFilter(null);
                setError(err);
                setLoadingFilter(false);
            });
        }
    }, []);
    var errorComponent = error ? (_jsxs("div", { children: [_jsx(Typography, __assign({ color: "error", variant: "h6" }, { children: "Error loading filter" })), _jsx(Typography, __assign({ variant: "body2", color: colors.rsLightestBrown }, { children: error.message }))] })) : null;
    var loadingComponent = loadingFilter ? (_jsxs(Typography, __assign({ color: "primary", variant: "h6" }, { children: ["Loading... ", _jsx(CircularProgress, {})] }))) : null;
    var customizationCount = Object.keys(filterConfig !== null && filterConfig !== void 0 ? filterConfig : {}).length;
    var filterComponent = parsedFilter ? (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ style: { display: 'flex', gap: '1rem', alignItems: 'center' } }, { children: [_jsx(Typography, __assign({ variant: "h6", color: colors.rsLightestBrown }, { children: "Importing Filter" })), _jsx(TextField, { label: "Filter Name", value: (_a = parsedFilter.filter) === null || _a === void 0 ? void 0 : _a.name, helperText: ((_b = parsedFilter.filter) === null || _b === void 0 ? void 0 : _b.name.trim()) === ''
                            ? 'Name cannot be empty'
                            : null, error: ((_c = parsedFilter.filter) === null || _c === void 0 ? void 0 : _c.name.trim()) === '', onChange: function (e) {
                            if (parsedFilter === null || parsedFilter === void 0 ? void 0 : parsedFilter.filter) {
                                setParsedFilter(__assign(__assign({}, parsedFilter), { filter: __assign(__assign({}, parsedFilter.filter), { name: e.target.value, source: filterUrl }) }));
                            }
                        } }), _jsxs(Typography, __assign({ variant: "h6", color: colors.rsLightestBrown }, { children: ["with ", customizationCount, " customizations from", ' ', _jsx("a", __assign({ href: filterUrl !== null && filterUrl !== void 0 ? filterUrl : '#' }, { children: !!filterUrl ? new URL(filterUrl).hostname : null }))] })), _jsx(Button, __assign({ sx: {
                            height: 'fit-content',
                            marginLeft: 'auto',
                            alignSelf: 'center',
                        }, size: "small", variant: "outlined", color: "secondary", onClick: function () {
                            updateFilter(__assign(__assign({}, parsedFilter.filter), { source: filterUrl, importedOn: new Date().toISOString() }));
                            setActiveFilter(parsedFilter.filter.id);
                            setFilterConfiguration(parsedFilter.filter.id, filterConfig || DEFAULT_FILTER_CONFIGURATION);
                            navigate('/');
                        } }, { children: "Import" }))] })), _jsx("div", { children: _jsx(CustomizeTab, { extraComponent: _jsx(Typography, __assign({ color: colors.rsDarkOrange, variant: "body2", fontSize: 24 }, { children: "Check out the modules below. If you'd like to import this filter and customize it, press import on the right." })), filter: parsedFilter.filter, config: filterConfig, readonly: true, onChange: function () { }, clearConfiguration: function () { }, setEnabledModule: function () { } }) })] })) : null;
    return (_jsxs(Container, __assign({ maxWidth: "xl" }, { children: [loadingComponent, errorComponent, filterComponent] })));
};
